import React, { useCallback, useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  UncontrolledTooltip,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
  Input,
  InputGroup,
} from "reactstrap";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import Reciver from "./Reciver";
import Sender from "./Sender";
import * as url from "../../../helpers/url_helper"
import axios from "axios";
import { Config } from "helpers/backend_helper";

//Import Scrollbar
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

const ChantBox = (props) => {
  const [searchMenu, setSearchMenu] = useState(false);
  const [settingsMenu, setSettingsMenu] = useState(false);
  const [otherMenu, setOtherMenu] = useState(false);

  const [text, setText] = useState("");
  const [messages, setMessages] = useState([]);

  const [messageBox, setMessageBox] = useState(null);
  const [userId, setUserId] = useState("")
  const [userName, setUserName] = useState("")

  const scrollToBottom = useCallback(() => {
    if (messageBox) {
      messageBox.scrollTop = messageBox.scrollHeight + 1000;
    }
  }, [messageBox]);

  useEffect(() => {
    if ((messages || []).length > 1) {
      scrollToBottom();
    }
  }, [messages, scrollToBottom]);

  

  const getChats = () =>{
    axios.get(`${url.CHAT}?${props.cId}`, Config).then((r)=>{
      setMessages(r.data)
    }).catch((e)=>{
      console.log(e)
    })
  }
  useEffect(()=>{
    const obj = JSON.parse(localStorage.getItem("authWTUser"));
    setUserId(obj.id)
    setUserName(obj.username)
    getChats()
  },[])
  const onSendMessage = () => {
    const obj = JSON.parse(localStorage.getItem("authWTUser"));
    const name = obj && obj.username ? obj.username : "Admin";


    let data = {}
    if(userId == props.handlerId){
      data = {
        cId: props.cId,
        sId: userId,
        rId: props.assignedBy,
        msg: text
      }
    }else{
      data = {
        cId: props.cId,
        sId: userId,
        rId: props.handlerId,
        msg: text
      }
    }
    axios.post(url.CHAT, JSON.stringify(data), Config).then((r)=>{
      if(r.data.status == 1){
        console.log('sent..')
        setText("");
      }
      getChats();
    }).catch((e)=>{
      console.log(e)
    })
  };

  return (
    <React.Fragment>
    {(messages.length > 0)?(
          <CardBody >
            <div>
              <div className="chat-conversation">
                <PerfectScrollbar
                  style={{ marginBottom: "1rem", maxHeight: "460px" }}
                  containerRef={ref => setMessageBox(ref)}
                >
                  <ul className="list-unstyled">
                    {(messages || []).map((message, index) => (
                      <React.Fragment key={index}>
                        {message["isSender"] ? (
                          <Reciver message={message} />
                        ) : (
                          <Sender message={message} />
                        )}
                      </React.Fragment>
                    ))}
                  </ul>
                </PerfectScrollbar>
              </div>
            </div>
          </CardBody>
          ):(
            <div className="text-center">
                <div className="mb-4">
                <i className="mdi mdi-check-circle-outline text-warning display-4" />
                </div>
                <div>
                <h5>No Messages</h5>
                <p className="text-muted">
                        
                </p>
                </div>
            </div>)}

          {(props.status != "Closed") && (
            <Row  className="modal-footer justify-content-center">
              <Col md={12}>
                
                  <textarea
                    className="form-control rounded"
                    placeholder="Enter Message..."
                    value={text}
                    onChange={e => setText(e.target.value)}
                  />
          
                
              </Col>
              
              <div className="col-auto">
                <Button
                  color="primary" 
                  className="chat-send w-md btn-rounded "
                  onClick={() => onSendMessage()}
                >
                  <span className="d-none d-sm-inline-block me-2">Send</span>{" "}
                  <i className="mdi mdi-send" />
                </Button>
              </div>
               
            </Row>
            )}
       
    </React.Fragment>
  );
};
ChantBox.propTypes = {
    status: PropTypes.any,
    handlerId: PropTypes.any,
    assignedBy: PropTypes.any,
    cId: PropTypes.any
  };
export default ChantBox;
